export default __webpack_public_path__ + "static/media/dark-paths.5f3de32e.png";